import { render } from "./ImageGalleryPopUp.vue?vue&type=template&id=20413db2&scoped=true"
import script from "./ImageGalleryPopUp.vue?vue&type=script&lang=js"
export * from "./ImageGalleryPopUp.vue?vue&type=script&lang=js"

import "./ImageGalleryPopUp.vue?vue&type=style&index=0&id=20413db2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20413db2"]])

export default __exports__